import React from "react"
import {makeStyles} from "@material-ui/core/styles"
import Tooltip from "@material-ui/core/Tooltip"

const useStylesBootstrap = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: "var(--modes-on-primary-container)",
    borderRadius: "4px",
    color: "var(--modes-background)",
    fontFamily: "var(--font-family-regular)",
    fontSize: "var(--font-size-paragraph-large)",
    fontWeight: "var(--font-weight-regular)",
    lineHeight: "var(--line-height)",
    padding: "10px",
    textAlign: "center",
  },
  arrow: {
    color: "var(--modes-on-primary-container)",
  },
}))

export function BootstrapTooltip(props) {
  const classes = useStylesBootstrap()

  return <Tooltip arrow classes={classes} {...props} />
}
